export const siteConfig = {
  name: "aComputer",
  serviceName: "Profesionální správa firemních profilů na Firmy.cz",
  shortDescription:
    "Váš firemní profil na Firmy.cz je zlatý důl. Získejte absolutní maximum ze Seznamu a Mapy.cz, přiveďte si nové zákazníky a o zbytek se postaráme my.",
  url: process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.acomputer.cz",
  locale: "cs_CZ",
  language: "cs",
  contact: {
    phone: "[DOPLNIT: TELEFON]",
    email: "[DOPLNIT: E-MAIL]",
    phoneHref: "",
    emailHref: "",
  },
  legal: {
    privacy: "[DOPLNIT: ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ]",
    privacyHref: "",
  },
  socials: [
    { label: "LinkedIn", href: "[DOPLNIT: LINKEDIN]" },
    { label: "Facebook", href: "[DOPLNIT: FACEBOOK]" },
    { label: "Instagram", href: "[DOPLNIT: INSTAGRAM]" },
  ],
} as const;
